// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1SgSQ","image":"Header_image__226NV","name":"Header_name__D_N8H","info":"Header_info__97jHM","infoRow":"Header_infoRow__2vmS6"};